import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
  isDownload?: boolean;
};

export const FeedbackModalThanks = ({ onClose, isDownload }: Props) => {
  const { t } = useTranslation();

  return (
    <div className='flex w-full max-w-[400px] flex-col items-center justify-center gap-8'>
      <div className='flex flex-col items-center justify-center gap-4'>
        <img
          src='https://assets.share-a-cart.com/images/next/dog-thank-you.gif'
          width='150px'
          height='125px'
          alt='Thank you GIF'
          className='rounded-[32px]'
        />
        <p className='text-200 text-center text-primary-dark'>
          {isDownload
            ? t('get.thanks_for_installing_the_sac_ext')
            : t('get.we_genuinely_appreciate_your_feedback')}
        </p>
      </div>
      <button onClick={onClose} className='button-primary h-12'>
        {t('get.back_to_cart')}
      </button>
    </div>
  );
};
